import createComponent from '../create-component';
export default createComponent([["title",{"key":"svg-title"}],["g",{"mask":"url(#arbitrum-one-mono_svg__a)","key":"svg-g"}],["defs",{"key":"svg-defs"}]]);